'use client';

import { c as _c } from "react/compiler-runtime";
import { ReportChartCard } from '@/domains/reports/report-page/ReportChartCard';
import { cn } from '@/utils/shad';
import type { ReactNode } from 'react';
type NebulyPageCardProps = {
  title: string;
  description?: string;
  children: ReactNode;
  contentClassName?: string;
  testId?: string;
  headerTrailing?: ReactNode;
  headerTitleClassName?: string;
  titleChipClassName?: string;
  headerToolbarClassName?: string;
  headerTrailingClassName?: string;
  className?: string;
  /** Stretch the card to fill a flex/grid sibling column (e.g. over-time chart beside KPI stack). */
  fillHeight?: boolean;
};
export function NebulyPageCard(t0) {
  const $ = _c(20);
  const {
    title,
    description,
    children,
    contentClassName,
    testId,
    headerTrailing,
    headerTitleClassName,
    titleChipClassName,
    headerToolbarClassName,
    headerTrailingClassName,
    className,
    fillHeight: t1
  } = t0;
  const fillHeight = t1 === undefined ? false : t1;
  const t2 = fillHeight && "flex-1";
  let t3;
  if ($[0] !== className || $[1] !== t2) {
    t3 = cn("min-h-0", t2, className);
    $[0] = className;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== children || $[4] !== contentClassName || $[5] !== description || $[6] !== headerTitleClassName || $[7] !== headerToolbarClassName || $[8] !== headerTrailing || $[9] !== headerTrailingClassName || $[10] !== t3 || $[11] !== title || $[12] !== titleChipClassName) {
    t4 = <ReportChartCard title={title} description={description} headerTrailing={headerTrailing} headerTitleClassName={headerTitleClassName} titleChipClassName={titleChipClassName} headerToolbarClassName={headerToolbarClassName} headerTrailingClassName={headerTrailingClassName} contentClassName={contentClassName} className={t3}>{children}</ReportChartCard>;
    $[3] = children;
    $[4] = contentClassName;
    $[5] = description;
    $[6] = headerTitleClassName;
    $[7] = headerToolbarClassName;
    $[8] = headerTrailing;
    $[9] = headerTrailingClassName;
    $[10] = t3;
    $[11] = title;
    $[12] = titleChipClassName;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  const card = t4;
  if (!testId) {
    return card;
  }
  const t5 = fillHeight && "flex h-full min-h-0 flex-1 flex-col";
  let t6;
  if ($[14] !== t5) {
    t6 = cn(t5);
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== card || $[17] !== t6 || $[18] !== testId) {
    t7 = <div data-testid={testId} className={t6}>{card}</div>;
    $[16] = card;
    $[17] = t6;
    $[18] = testId;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  return t7;
}